import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as UserActions from '../actions/user.actions';
import { UserManangementService } from '../../services/repos/user-management/user-manangement.service';
import { UserAccountService } from '../../services/api/user-account/user-account.service';

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private userManagementService: UserManangementService,
    private userAccountService: UserAccountService
  ) {}

  loadUserPermissions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadUserPermissions),
      mergeMap((action) => {
        console.log('Effect triggered to load permissions for userId:', action.userId);
        // if (action.userId === '0') {
        //   console.log('Invalid user ID provided, returning failure action');
        //   return of(UserActions.loadUserPermissionsFailure({ error: 'Invalid user ID' }));
        // }
        return this.userManagementService.getUserPermissions(action.userId).pipe(
          map((permissions) => UserActions.loadUserPermissionsSuccess({ permissions })),
          catchError((error) =>
            of(
              UserActions.loadUserPermissionsFailure({
                error: error?.message || 'Failed to load user permissions',
              })
            )
          )
        )
      }
      )
    );
  });

  loadUserAccount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadUserAccount),
      mergeMap(() =>
        this.userAccountService.getAccount().pipe(
          map((account) => UserActions.loadUserAccountSuccess({ account })),
          catchError((error) =>
            of(
              UserActions.loadUserAccountFailure({
                error: error?.message || 'Failed to load user account',
              })
            )
          )
        )
      )
    );
  });
}
